/**
 * Moduł podpowiedzi dla wyszkukiwarki.
 * @type {module}
 */
app.service('autocomplete', function (searchHistory, search, loading, cookie, front, pageConfig, autocompleteInfo, logData, developSearchModeTest, price) {
	var $input;
	var $results;
	var $searchBox;
	var $sidebarResults;
	var $container;
	var $resultsItem;
	var $keyboardFocusedItem;
	var $srSearchAnnouncer;
	var isSidebarKeyboardFocused = false;
	var $activeCategory;
	var $lastAjax=null;
	var $loadProductsAjax=null;
	var searchTimeout = false;
	var inputTimeout = false;
	var impressionsTimeout = false;
	var savedProducts = [];
	var testAB;

	var keyName = {
		up: 'ArrowUp',
		down: 'ArrowDown',
		left: 'ArrowLeft',
		right: 'ArrowRight',
		enter: 'Enter',
		esc: 'Escape'
	};
	var options = {
		minInputLength: 3,
		maxInputLength: 64,
		charactersInQueryLimit: 64,
		historyLimit: 2,
		resultsLimit: 5,
		ajaxUrl: '/searchAutocomplete.ltr',
		loadProductsTimeout: 250,
		impressionsTimeout: 1000,
		inputTimeout: 200
	};
	var lastResponse = {};
	var summaryResults = {};
	var linkName = '';

	function copyToInput(el) {
		$input.val(el);
	}
	function keyboardNav(e) {	// obsługa klawiatury
		const $item = $('#ac-results .ac-item');
		const $focusedItem = $('#ac-results .ac-item-focused');
		let $activeItem = $('#ac-results .ac-active');
		const $sidebarItem = $('#sidebar-results .ac-sidebar-item');
		let $activeSidebarItem = $('#sidebar-results .ac-sidebar-item-focused');

		if (e.type === 'ac:right' && $activeItem.length && !$activeItem.hasClass('ac-group-saved') && $activeSidebarItem.length === 0) { // przejście pseudo-focusem na wyniki w ramach #sidebar-results
			$focusedItem.removeClass('ac-item-focused');
			isSidebarKeyboardFocused = true;
			$activeSidebarItem = $sidebarItem.first('.ac-sidebar-item');
			$activeSidebarItem.addClass('ac-sidebar-item-focused');
			$keyboardFocusedItem = $activeSidebarItem;
		}

		if (e.type === 'ac:left' && isSidebarKeyboardFocused) { // powrót pseudo-focusem na podpowiedzi z #ac-results
			$focusedItem.removeClass('ac-item-focused');
			$activeItem.addClass('ac-item-focused');
			clearSidebarKeyboardFocus();
			$activeSidebarItem = null;
			$keyboardFocusedItem = $activeItem;
		}

		if (e.type === 'ac:up' || e.type === 'ac:down') {
			if (isSidebarKeyboardFocused) { // pseudo-focus w ramach podpowiedzianych produktów (#sidebar-results)
				if ($activeSidebarItem.length) {
					if (e.type === 'ac:down') {
						$activeSidebarItem = $sidebarItem.last('.ac-sidebar-item').hasClass('ac-sidebar-item-focused') ? $sidebarItem.first('.ac-sidebar-item') : $activeSidebarItem.next('.ac-sidebar-item');
					}
					if (e.type === 'ac:up') {
						$activeSidebarItem = $sidebarItem.first('.ac-sidebar-item').hasClass('ac-sidebar-item-focused') ? $sidebarItem.last('.ac-sidebar-item') : $activeSidebarItem.prev('.ac-sidebar-item');
					}
					$sidebarItem.removeClass('ac-sidebar-item-focused');
					$activeSidebarItem.addClass('ac-sidebar-item-focused');
				} else {
					$activeSidebarItem = $sidebarItem.first('.ac-sidebar-item');
					$activeSidebarItem.addClass('ac-sidebar-item-focused');
				}
				$keyboardFocusedItem = $activeSidebarItem;

			} else {
				if ($activeItem.length) {
					if ($activeItem.hasClass('ac-group-saved')) { // obsługa pseudo-focusa dla zapamietanej listy ostatnich wyszukiwań (#ac-results)

						if ($activeItem.hasClass('ac-active') && $activeItem.hasClass('ac-item-focused')) {
							$focusedItem.removeClass('ac-item-focused');
							if (e.type === 'ac:down') {
								$keyboardFocusedItem = $activeItem.find('.ac-forget').addClass('ac-item-focused');
							}
							if (e.type === 'ac:up') {
								$activeItem.removeClass('ac-active');
								$activeItem = $activeItem.prev('.ac-item');
								$activeItem.addClass('ac-active');
								copyToInput($('.ac-text', $activeItem).text());
								$keyboardFocusedItem = $activeItem.find('.ac-forget').addClass('ac-item-focused');
							}
						} else if ($activeItem.hasClass('ac-active') && $activeItem.find('.ac-forget').hasClass('ac-item-focused')) {
							$focusedItem.removeClass('ac-item-focused')
							if (e.type === 'ac:down') {
								$activeItem.removeClass('ac-active');
								$activeItem = $activeItem.next('.ac-item');
								$activeItem.addClass('ac-active').addClass('ac-item-focused');
								copyToInput($('.ac-text', $activeItem).text());
							}
							if (e.type === 'ac:up') {
								$activeItem.addClass('ac-item-focused');
							}
						}
					} else { // pozostałe przypadki przechodzenia po sugerowanych hasłach (#ac-results)
						$item.removeClass('ac-active')
						$focusedItem.removeClass('ac-item-focused');
						$activeItem = (e.type === 'ac:up') ? $activeItem.prev('.ac-item') : $activeItem.next('.ac-item');
						$activeItem.addClass('ac-active').addClass('ac-item-focused');
						copyToInput($('.ac-text', $activeItem).text());
					}
				} else {
					$focusedItem.removeClass('ac-item-focused');
					$activeItem = (e.type === 'ac:up') ? $item.last('.ac-item') : $item.first('.ac-item');
					$activeItem.addClass('ac-active');
					if ($activeItem.hasClass('ac-group-saved') && e.type === 'ac:up') {
						$keyboardFocusedItem = $activeItem.find('.ac-forget').addClass('ac-item-focused');
					} else {
						$activeItem.addClass('ac-item-focused');
						$keyboardFocusedItem = $activeItem;
					}
					copyToInput($('.ac-text', $activeItem).text());
				}


				if ($activeItem.hasClass('ac-active') && !$activeItem.find('.ac-forget').hasClass('ac-item-focused')) {
					$focusedItem.removeClass('ac-item-focused');
					$activeItem.addClass('ac-item-focused');
					$keyboardFocusedItem = $activeItem;
					$activeItem.trigger('mouseenter');
					setActiveCategory($activeItem);
				} else if (!$activeItem.hasClass('ac-active')) {
					$focusedItem.removeClass('ac-item-focused');
					$keyboardFocusedItem = null;
					announcePseudoFocusedItem($input);
				}
			}
		}
		announcePseudoFocusedItem($keyboardFocusedItem);
		highlightMatchedResults();
	}
	function clearAllKeyboardFocus() {
		$('#ac-results .ac-item-focused').removeClass('ac-item-focused');
		$keyboardFocusedItem = null;
		clearSidebarKeyboardFocus();
	}
	function clearSidebarKeyboardFocus() {
		isSidebarKeyboardFocused = false;
		$sidebarResults.find('.ac-sidebar-item').removeClass('ac-sidebar-item-focused');
	}
	function announcePseudoFocusedItem($element) {
		if ($element && $element.length) {
			// określenie wiadomości dla SR w zależności od typu focusowanego elementu
			const { message } = getAnnounceData($element);
			// przekazanie treści do elementu aria-live
			$srSearchAnnouncer.text(message);
		}
	}
	function getAnnounceData($element) {
		const data = {
			type: '',
			message: ''
		}
		switch (true) { // treści wiadomości dla SR w zależności od klasy focusowanego elementu
			case $element.hasClass('ac-group-staticSuggestions'):
				data.type = 'ac-group-staticSuggestions';
				data.message = 'Naciśnij Enter, aby wyszukać. Naciśnij strzałkę w prawo, aby przejść do polecanych produktów dla hasła ' + $element.data('text') + '. Naciśnij strzałkę w dół, aby przejść do kolejnego hasła';
				break;
			case $element.hasClass('ac-group-categorySuggestions'):
				data.type = 'ac-group-categorySuggestions';
				data.message = 'Naciśnij Enter, aby wyszukać. Naciśnij strzałkę w prawo, aby przejść do polecanych produktów dla hasła ' + $element.data('text') + '. Naciśnij strzałkę w dół, aby przejść do kolejnego hasła';
				break;
			case $element.hasClass('ac-group-suggestions'):
				data.type = 'ac-group-suggestions';
				data.message = 'Naciśnij Enter, aby wyszukać. Naciśnij strzałkę w prawo, aby przejść do polecanych produktów dla hasła ' + $element.data('text') + '. Naciśnij strzałkę w dół, aby przejść do kolejnego hasła';
				break;
			case $element.hasClass('search-products-item'):
				data.type = 'search-products-item';
				data.message = 'Polecany produkt ' + $element.find('.product-name').text().trim() + '. Naciśnij Enter, aby przejść na kartę produktu. Naciśnij strzałkę w dół, aby przejść na kolejny produkt. Naciśnij strzałkę w lewo, aby wrócić do listy popularnych haseł.';
				break;
			case $element.hasClass('products-link'):
				data.type = 'products-link';
				data.message = 'Więcej produktów. Naciśnij Enter aby przejść do wszystkich produktów. Naciśnij strzałkę w lewo, aby wrócić do listy popularnych haseł.';
				break;
			case $element.hasClass('ac-group-saved'):
				data.type = 'ac-group-saved';
				data.message = 'Ostatnie wyszukiwanie, Naciśnij Enter, aby wyszukać';
				break;
			case $element.hasClass('ac-forget'):
				data.type = 'ac-forget';
				data.message = 'wyczyść. Naciśnij Enter, aby usunąć ' + $element.parents('.ac-group-saved').data('text') + ' z historii wyszukiwania';
				break;
			case $element.is($input) && $input.val() === '':
				data.type = 'search-input-empty';
				data.message = 'Wpisz hasło do wyszukania.';
				break;
			default:
				data.type = 'unknown';
		}
		return data;
	}
	function setActiveCategory(item) {
		$("#search-category").val($(item).attr("data-category"));
	}
	function onKeyUp(e) {
		if (e.key != ' ' && $.inArray(e.key, ['Control']) == -1) {
			keyTest(e.key);
		}
	}
	function onChoose() {
		var obj = {};
		var active = $keyboardFocusedItem || $("#ac-results .ac-active");
		var text = active.data("text") || $input.val();
		var url = active.data("url") || active.attr("href") || "";
		obj[text] = { link: url };

		if (active.hasClass('ac-forget')) { // obsluga usuwania z historii wyszukiwania z poziomu klawiatury
			searchHistory.remove(active.parent().data('text'));
			active.parent().remove();
			$input.trigger('ac:down');
			return;
		}
		if(text.length > 1){
			searchHistory.add(obj);
		}
		if(!!url) {
			loading.start();
			document.location.href=url;
		} else {
			search.search(text);
		}
		$input.trigger('blur');
	}
	function getActiveCategory() {
		return $.trim($("#search-category").val());
	}
	function onEsc() {

	}
	function onOpen(e) {
		$searchBox.addClass("ac-open");
		$activeCategory = getActiveCategory();
		var q = e.target.value;
		if(q.length < 3) {
			if((front.katalog && q.length>1) || !front.katalog){
				$input.trigger('ac:inputShort');
			} else if(front.katalog && q.length<=1) {
				$searchBox.addClass('empty');
			}
		} else {
			$input.trigger('ac:inputLong');
			$searchBox.addClass('searching');
		}
	}
	function onInputShort() {
		var q = $input.val();
		lastResponse = {};
		summaryResults = $.extend({}, find(q));
		render();
	}
	function startsWith(str, str2) {
		return str.indexOf(str2) === 0;
	}
	function filterResponse(item) {
		var exist = false;
		$.each(lastResponse, function(name, group){
			$.each(group, function(key, obj) {
				if(this.name === item) {
					exist = true;
				}
			});
		});
		return exist;
	}
	function find(q) {
		var his = searchHistory.get();
		var suggestions = {saved:[]};
		$.each(his, function(i, obj) {
			if(Object.keys(obj).length === 0){
				return false;
			}
			var keyword = Object.keys(obj)[0];
			var keywordLower = keyword.toLowerCase();
			if(startsWith(keywordLower, q.toLowerCase()) && !filterResponse(keywordLower.toLowerCase())) {
				suggestions.saved.push({name: keyword, url: obj[keyword].link});
			}
		});
		suggestions.saved = suggestions.saved.slice(0, options.historyLimit);
		if (suggestions.saved.length) {
			autocompleteInfo.setData({
				type: 'history',
				historyLength: suggestions.saved.length
			});
		}
		return suggestions;
	}
	function onInputLong(e) {
		var q = $input.val();
		var newLinkName = getLinkName();

		if($.isEmptyObject(lastResponse) || linkName != newLinkName) {
			onQuery(e);
			return;
		}
		summaryResults = $.extend({}, find(q), lastResponse);
		render();
	}

	function getPromotionSuggestion ({ name, link, image }) {
		return `
			<div role="link" class="ac-item ac-group-promotion" data-url="${link}">
				<img src="${image}" title="${name}" /> <div class="promotion-text">${name}</div>
			</div>
		`;
	}

 	function render() {
		var $tempResults = $results.detach();
		var n = 1;
		var preparedResults = 1;
		var savedAutocomplete = 1;
		clearResults();
		function prepareResults(groups) {
	 		$.each(groups, function(name, group){
				if (name === 'promotionSuggestion' && group) {
					var promotionSuggestion = getPromotionSuggestion(groups.promotionSuggestion);
					$tempResults.find('.ac-group-categorySuggestions').last().after(promotionSuggestion);
					preparedResults++;
				} else {
					$.each(group, function(j, obj){
						preparedResults++;
						if(n <= options.resultsLimit) {
							if (name === 'saved') {
								savedAutocomplete++;
							}
							$tempResults.append(prepareItem(obj, name, j+1));
							n++;
						}
					});
				}
			});
			if(preparedResults - savedAutocomplete === 0) {
				$searchBox.removeClass('searching empty');
				if (savedAutocomplete === 1) {
					$searchBox.addClass('empty');
				}
			} else {
				$searchBox.removeClass('empty');
				if(preparedResults > savedAutocomplete) {
					$searchBox.addClass('searching');
				}
			}
			// wyczyszczenie sekcji zapamiętanych wyszukiwań, jeśli są sugerowane wyniki
			$tempResults.find('.ac-group-categorySuggestions').length ? $tempResults.find('.ac-group-saved').remove() : null;
	 		return $tempResults;
		 }
		$container.prepend(prepareResults(summaryResults));
 	}
	function onQuery(e) {
		var q = e.target.value.replace(/[^ąćęłńóśźżĄĆĘŁŃÓŚŹŻ\w\s]/gi, ' ').trim();
		q = q.slice(0, options.charactersInQueryLimit);

		clearTimeout(inputTimeout);
		if(q.length < 3) {
			onInputShort();
			return;
		} else {
			inputTimeout = setTimeout(function(){
				searching(e, q);
			}, options.inputTimeout);
		}
	}
	function searching(e, q) {
		linkName = getLinkName();
		if($lastAjax!==null){
			$lastAjax.abort();
			$lastAjax=null;
		}
		var data = {
			keyword: q,
			linkName: linkName || '0'
		}
		if (front.katalog) {
			data.wcShopCode = pageConfig.getData('wc').shopCode;
		}
		$lastAjax=$.ajax({
			url: options.ajaxUrl,
			data: $.extend(data, {developSearchMode: developSearchModeTest.isEnabled()}),
			success: function(response) {
				lastResponse = response;
				onInputLong(e);
				var categorySuggestionsLength = lastResponse.categorySuggestions && lastResponse.categorySuggestions.length ? lastResponse.categorySuggestions && lastResponse.categorySuggestions.length : 0;
				var suggestionsLength = lastResponse.suggestions && lastResponse.suggestions.length ? lastResponse.suggestions.length : 0
				if (categorySuggestionsLength){
					let res = lastResponse.categorySuggestions[0];
					loadProducts(res, true);
					autocompleteInfo.setData({
						count: categorySuggestionsLength + suggestionsLength,
						categoryLength: categorySuggestionsLength,
						suggestionsLength: suggestionsLength,
						category:{
							type: 'category',
							position: 1,
							text: res.name,
							fullText: res.categorySufix ? res.name+res.categorySufix : res.name,
							category: res.categoryName
						}
					});

				} else if (suggestionsLength){
					let res = lastResponse.suggestions[0];
					loadProducts(res);
					autocompleteInfo.setData({
						count: categorySuggestionsLength + suggestionsLength,
						categoryLength: categorySuggestionsLength,
						suggestionsLength: suggestionsLength,
						category:{
							type: 'suggestions',
							position: 1,
							text: res.name,
							fullText: res.categorySufix ? res.name+res.categorySufix : res.name,
							category: res.categoryName
						}
					});
				}
			},
			error: function() {
				lastResponse = {};
			}
		});
	}
	function getLinkName() {
		return $("#search-category").val();
	}
	function onForget(e) {
		e.stopPropagation();
		var text = $(this).prev().text();
		var $parent = $(this).parent();
		searchHistory.remove(text);
		$parent.remove();
	}
	function onCloseAC(e) {
		if(!$(e.target).closest('.ac-container').length && $($searchBox).hasClass("ac-open") || $(e.target).is('#search-input-clear')) {
			$searchBox.removeClass("ac-open");
			clearResults();
			$("#search-category").val($activeCategory);
			clearAllKeyboardFocus();
		}
	}
	function clearResults() {
		$results.html('');
	}
	function prepareLink(link){
		let testAB = cookie.get('searchTestAB');
		if(link){
			if(testAB === 'G'){
				link = link.replace('/search.bhtml', '/search2.bhtml');
			} else if(testAB === 'P'){
				link = link.replace('/search.bhtml', '/search3.bhtml');
			}
			if (link.indexOf('optimized_search=1') === -1) { // dodanie parametru optimized_search=1 do linków tylko jeśli już go nie mają
				link += link.indexOf('?') === -1 ? '?' : '&';
				link += 'optimized_search=1';
			}
			return link;
		}
		return false;
	}
	function highlightInputMatch(text, inputVal) {
		if(inputVal) {
			return text.replace(new RegExp('(' + inputVal + ')', 'gi'), "<b>$1</b>");
		}
	}
	function highlightMatchedResults() {
		const inputVal = $input.val();
		const $resultsItemsText = $("#ac-results .ac-item:not(.ac-group-saved) .ac-text");
		if (inputVal && $resultsItemsText.length) {
			$resultsItemsText.each(function(itemIndex, textElement) {
				textElement.innerHTML = highlightInputMatch(textElement.innerText, inputVal);
			});
		}
	}
	function prepareItem(obj, groupname, position) {
		var val = $input.val();
		val = val.replace(/[^ąćęłńóśźżĄĆĘŁŃÓŚŹŻ\w\s]/gi, ' ').trim();
		var text = obj.name;
		if(val) text = highlightInputMatch(obj.name, val);
		var group = '';
		if(groupname == "categorySuggestions") {
			group = 'category';
		} else if(groupname == "suggestions") {
			group = 'suggestion';
		} else if(groupname == "saved") {
			group = 'history';
		}
		var $item = $('<div/>', {
 			'class': 'ac-item ac-group-' + groupname,
 			'data-text': obj.name,
			'data-full-text': obj.categorySufix ? obj.name+' '+obj.categorySufix : obj.name,
			'data-position': position,
 			'data-url': prepareLink(obj.link) || prepareLink(obj.url) || prepareLink('/search.bhtml?keyword=' + obj.name),
 			'data-category': obj.categoryName || "0",
			'data-group': group
		 });

 		var textEl = $("<span/>", {'class':"ac-text"}).html(text);
 		var textCat = $("<i/>", {text: obj.categorySufix});
		$item.append(textEl);
		$item.on('mouseenter', function() {
			loadProducts(obj);
		});
 		if(obj.categorySufix) $item.append(textCat);
		if(groupname === 'saved') {
			$item.append($("<span/>", {
				'class': 'ac-forget',
				text: 'wyczyść',
			}));
		}
 		return $item;
 	}
	function highlightOn(element) {
		$("#ac-results .ac-item").removeClass('ac-active').not(this);
		var $this = $(this);
		$this.addClass('ac-active');
		autocompleteInfo.setData({
			category:{
				type: $this.data('group'),
				position: $this.data('position'),
				text: $this.data('text'),
				fullText: $this.data('fullText'),
				category: $this.data('category')
			}
		});
	}

	function loadProducts(autocompleteItem, force = false) {
		function load(){
			if(data.suggestion && data.suggestion.length){
				$sidebarResults.addClass('loading');
				if($loadProductsAjax !== null){
					$loadProductsAjax.abort();
				}

				$loadProductsAjax = $.ajax({
					url: '/searchAutocompleteProducts.ltr',
					method: 'GET',
					data: $.extend(data, {developSearchMode: developSearchModeTest.isEnabled()}),
					success: function (result) {
						generateTemplate(result.products, autocompleteItem.link, text);
						savedProducts.push({keyword: data.suggestion, result, link: autocompleteItem.link, text: text});
					},
					error:function(){
						//
					},
					complete: function () {
						$sidebarResults.removeClass('loading');
						if (isSidebarKeyboardFocused) {
							$keyboardFocusedItem = $sidebarResults.find('.ac-sidebar-item').first().addClass('ac-sidebar-item-focused');
							announcePseudoFocusedItem($keyboardFocusedItem);
						}
					}
				});
			}
		}
		clearTimeout(searchTimeout);
		autocompleteItem && autocompleteItem.name ? null : autocompleteItem = { name: '', linkName: ''};
		if (!autocompleteItem.link) {
			autocompleteItem.link = autocompleteItem.url ? autocompleteItem.url : prepareLink("/search.bhtml?keyword=" + autocompleteItem.name.replace(/ /g, '+'));
		}
		var text = autocompleteItem.name;
		if(autocompleteItem.categorySufix){
			text+=' '+autocompleteItem.categorySufix;
		}
		var data = {
			suggestion: autocompleteItem.name,
			linkName: autocompleteItem.linkName || undefined,
			userId: logData.customerId(),
			showRecommendationsFromAWSonMainPage: logData.showRecommendationsFromAWSonMainPage(),
		}
		if (front.katalog) {
			data.wcShopCode = pageConfig.getData('wc').shopCode;
		}

		const foundProducts = savedProducts.find(x => x.keyword === autocompleteItem.name);
		if(foundProducts) {
			generateTemplate(foundProducts.result.products, foundProducts.link, foundProducts.text);
		} else {
			searchTimeout = setTimeout(function() {
				load()
			},force ? 0 : options.loadProductsTimeout);
		}
	}

	function setListeners() {
		$(document).on("click", onCloseAC)
			.on('focusin', function(e) {
				if(!$(e.target).is($input)){
					onCloseAC(e);
				}
			});
		$input.on('ac:enter', function(){
			autocompleteInfo.logData({
				type: 'enter'
			});
			onChoose();
		});
		$input.on('ac:esc', onEsc);
		$input.on('keyup', onKeyUp);
		$input.on('keydown', function (e) { // blokada natywnego poruszania się strzałkami na inpucie
			if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)
				&& $keyboardFocusedItem && $keyboardFocusedItem.length && !$keyboardFocusedItem.hasClass('ac-group-saved')
			) {
				e.preventDefault();
				e.stopPropagation();
			}
		});
		if (testAB !== 'P') {
			$input.on('ac:query', onQuery);
			$input.on('focus', onOpen);
			$input.on('ac:up ac:down ac:left ac:right', keyboardNav);
			$input.on('ac:inputShort', onInputShort);
			$input.on('ac:inputLong', onInputLong);
		}
		$results.on('mouseenter mouseleave', '.ac-item', highlightOn);
		$results.on("click", '.ac-forget', onForget)
			.on("click", ".ac-item", function () {			// wyniki w lewej kolumnie
				var $this = $(this);
				autocompleteInfo.logData({
					type: $this.data('group'),
					category: {
						position: $this.data('position'),
						text: $this.data('text'),
						fullText: $this.data('full-text'),
						id: $this.data('category')
					},
					redirectLink: $this.attr('data-url')
				});
				onChoose();
			});
		$('#sidebar-results').on("click", ".search-products-item", function () {			// produkty w prawej kolumnie
			var $this = $(this);
			autocompleteInfo.logData({
				type: 'product',
				count: visibleProducts.length,
				product: visibleProducts.filter(function (item) { return item.id == $this.data('id') })[0],
				productName: $this.data('product-name').trim(),
				redirectLink: $this.attr('href')
			});
		}).on("click", ".products-link", function () {			// link więcej produktów pod proponowanymi produktami w prawej kolumnie
			autocompleteInfo.logData({
				type: 'more-products',
				count: visibleProducts.length,
				redirectLink: $(this).attr('href')
			});
		});
		$('#search-input-clear').on('click', function () {
			$input.val('').focus();
			clearSidebarKeyboardFocus();
		}).on('keydown', function (e) {
			if (e.key == 'Enter' || e.key == ' ') {
				e.preventDefault();
				e.stopPropagation();
			}
		}).on('keyup', function (e) {
			if (e.key == 'Enter' || e.key == ' ') {
				e.preventDefault();
				e.stopPropagation();
				$input.val('').focus();
				clearSidebarKeyboardFocus();
			}
		});

	}
	function keyTest(k) {
		switch (k) {
			case keyName.up:
				$input.trigger('ac:up');
				break;
			case keyName.down:
				$input.trigger('ac:down');
				break;
			case keyName.left:
				$input.trigger('ac:left');
				break;
			case keyName.right:
				$input.trigger('ac:right');
				break;
			case keyName.enter:
				$input.trigger('ac:enter');
				break;
			case keyName.esc:
				$input.trigger('ac:esc');
				break;
			default:
				$input.trigger('ac:query');
		}
	}

	var visibleProducts = [];

	function generateTemplate(products, link, suggestionText){
		var result = '';
		var keyword = $input.val();
		visibleProducts = [];
		
		products.forEach((product, i) => {
			// console.log('Autocomplete sugestion',product);
			let link = product.cardDefaultUrl ? prepareLink(product.cardDefaultUrl) : '#';
			let productPriceBox = '';
			let productPriceLabel = '';
			let opinionEnding = '';
			if(product.voucherDiscountedPriceAvailable){
				productPriceBox = `
					<div class="product-price price-voucher"> 
						<div class="price-normal">
							${product.voucherDiscountedPrice ? product.voucherDiscountedPrice + "&nbsp;zł" : ""}
						</div>
					</div>
				`
			} else {
				productPriceBox = `
					<div class="product-price ${product.discountedPriceAvailable ? ' discounted-price-available' : ''}"> 
						<div class="price-normal">
							${product.price ? product.price + "&nbsp;zł" : ""}
						</div>
					</div>
				`
			}
			if (product.priceLabelDto && !product.priceLabelDto.labelPhotoPath) { 
				productPriceLabel = `
					<div class="price-promotional-label smaller-promotional-label">
						<div class="price-promotional-label-name">${product.priceLabelDto.labelText}</div>
						<div class="price-promotional-label-discount">${product.priceLabelDto.discountAmount ? '-' + price.format(product.priceLabelDto.discountAmount) : ''}</div>
					</div>
				`;
			} else if (product.priceLabelDto && product.priceLabelDto.labelPhotoPath) {
				productPriceLabel = `
					<div class="price-promotional-label smaller-promotional-label">
						<div class="price-promotional-label-image">
							<img src="${product.priceLabelDto.labelPhotoPath}" alt="Euro Hit Cenowy"/>
						</div>
					</div>
				`;
			} else {
				productPriceLabel = '';
			}
			if(product.quantity) {
				opinionEnding = product.quantity == 1 ? 'opinia' : (product.quantity < 5 || (product.quantity > 20 && product.quantity%10 >= 2 && product.quantity%10 < 5)) ? 'opinie' : 'opinii';
			}

			result += `<a href="${link}" class="search-products-item ac-sidebar-item" data-id="${product.id}" tabindex="-1" data-product-name="${product.name ? product.name.replace(/"/g, '″') : ''}" data-product-category="${product.groupName ? product.groupName : ''}">
				<div class="product-photo">
				${product.photo ? `<img src="${product.photo}" alt="${product.name.replace(/"/g, '″')}"/>` : ''}
				${product.voucherDiscountedPriceAvailable ? `<span class="product-voucher-discount-label">Cena z kodem</span>` : ''}
				${product.discountedPriceAvailable ? `<span class="product-promotion-label">Promocja</span>` : ''}
				</div>
				<div class="product-content">
					<div class="title-box">
						<div class="product-name">
							${product.name ? product.name : ''}
						</div>
					</div>
					<div class="product-category">
						${product.groupName ? product.groupName : ""}
					</div>
					<div class="stars-rating">
						${product.cardDefaultUrl ? `
							<div>
								${product.grade ? `<span style="width:${20*product.grade}%;"></span>` : ''}
							</div>
							<div class="rating-count">
								${product.quantity ? `<b>${product.grade ? product.grade : ''}</b> <em>(${product.quantity} ${opinionEnding})</em>` : ""}</em>
							</div>
						` : ''}
					</div>
					<div class="product-price-box">
						${productPriceLabel}
						${productPriceBox}
					</div>
				</div>
			</a>`;
			if(suggestionText && keyword.length > 2){
				visibleProducts.push({
					id: product.id,
					plu: product.productInfoCode,
					list: 'Wyszukiwarka/Polecane produkty',
					position: (i+1),
					price: product.productInfoPrice,
					category: product.productInfoGroupName,
					name: product.productInfoName,
					brand: product.productInfoBrandName,
					variant: '',
					status: product.productInfoAvailabilityStatusCode,
					dimension56: keyword,
					dimension59: suggestionText
				});
			}
		});
		if(link){
			const firstProductGroupName = products[0] && products[0].groupName ? products[0].groupName : '';
			result += `<a class="products-link ac-sidebar-item" tabindex="-1" href="${prepareLink(link)}" data-product-category="${firstProductGroupName}">Więcej produktów</a>`;
		}
		$sidebarResults.html(result);
		if(suggestionText && keyword.length > 2 && products.length && visibleProducts.length){
			clearTimeout(impressionsTimeout);
			impressionsTimeout = setTimeout(function(){
				logImpressions();
			}, options.impressionsTimeout);
		}
	}
	var loggedImpressions = [];
	function logImpressions(){
		var result = [];
		if(visibleProducts && visibleProducts.length){
			visibleProducts.forEach((product, i) => {
				var isLogged = loggedImpressions.filter(function (item,j){
					return item.id == product.id && item.dimension56 == product.dimension56 && item.dimension59 == product.dimension59;
				});
				if(isLogged.length == 0){
					result.push(product);
					loggedImpressions.push(product);
				}
			});
			if(result.length){
				UA.push({
					'ecommerce': {
						'impressions': result
					}
				});
				UA.push({ 'event': 'productListView' });
			}
		}
	}

	function init() {
		testAB = cookie.get('searchTestAB');
		$input = $("#keyword");
		$results = $('#ac-results');
		$searchBox = $('#search-box');
		$srSearchAnnouncer = $('#sr-search-announcer');
		$sidebarResults = $('#sidebar-results');
		$container = $('#search-box-result');
		$resultsItem = $("#ac-results .ac-item");
		$activeCategory = getActiveCategory();
		options.historyLimit = front.getParam('autocomplete.historySuggestions');
		options.resultsLimit = front.getParam('autocomplete.maxSuggestions');
		options.charactersInQueryLimit = front.getParam('autocomplete.charactersInQueryLimit');
		options.loadProductsTimeout = front.getParam('autocomplete.loadProductsTimeout');
		options.impressionsTimeout = front.getParam('autocomplete.impressionsTimeout');
		options.inputTimeout = front.getParam('autocomplete.inputTimeout');
		linkName = getLinkName();
		$sidebarResults.addClass('loading');
		if(testAB !== 'P'){
			generateTemplate([{},{},{},{},{}], false, false);
		}
		setListeners();
	}

	return {
		init: init
	};
});
